import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import contentContract from './contract';
import useCandidate from '@authentication/hooks/useCandidate';
import { Divider, Typography } from '@mui/material';

interface Props {
  handleClickClose: () => void;
  open: boolean;
  handleAcceptContract: () => void;
}
export default function DialogContract({
  handleClickClose,
  open,
  handleAcceptContract,
}: Props) {
  const descriptionElementRef = React.useRef<HTMLElement>(null);

  const { candidate } = useCandidate();

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const fristNameLastnameCandidate: any = `${candidate?.user.firstname} ${candidate?.user.lastname}`;

  return (
    <Dialog
      sx={{
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(92, 89, 92, 0.88)',
      }}
      open={open}
      onClose={handleClickClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        Bienvenue {fristNameLastnameCandidate}
        <Typography sx={{ paddingBlock: '16px', fontWeight: 'bold' }}>
          Autorisation d’utilisation des données personnelles et du droit à
          l’image continuer.
        </Typography>
        <Divider />
      </DialogTitle>
      <DialogContent
        sx={{
          height: '55vh',
        }}
      >
        <DialogContentText
          id="scroll-dialog-description"
          sx={{
            color: '#1D1D1D',
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '24px',
          }}
          tabIndex={-1}
        >
          <Typography dangerouslySetInnerHTML={{ __html: contentContract }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          onClick={handleAcceptContract}
          sx={{
            background: '#A03A7E !important',
            borderRadius: '44px',
            color: '#A03A7E',

            marginBlock: '0.5rem',
            '&:hover': {
              background: '#A03A7E',
            },
          }}
        >
          <Typography
            sx={{
              color: '#FFF7FC',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '24px',
            }}
          >
            Accepter les Termes et Conditions d’utilisation
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
